<template>
  <div id="NotLoggedIn" class="bg-brand-secondary">
    <!--TODO::Refactor this section -->

  </div>
</template>

<script>
// @ is an alias to /src
import ErrorModal from "@/components/GP/ErrorModal.vue";

export default {
  name: "home",
  components: {
    ErrorModal
  },
  data() {
    return {

    };
  },
  mounted() {
    this.openErrorModal('Your session has expired', "Please log in and try again", true)
  },
  methods: {
    openErrorModal(title, error, redirect, goBack) {
      const content = this.$createElement(ErrorModal, { props: { title, error, redirect, goBack } })
      const skin = this.$store.getters.skin;
      let opts = {
        hideHeader: true,
        hideFooter: true,
        modalClass: "coach_modal theme-" + skin,
        size: "md",
        buttonSize: "sm",
        centered: true,
        contentClass: "coach_modal",
        id: 'error-modal'
      }
      return this.$bvModal.msgBoxOk(content, opts);
    },
  },
  computed: {
  },
  watch: {

  },
};
</script>
<style lang="less">
#NotLoggedIn {
  height: 100%;
}
</style>
